import { useState, ReactNode, useId } from "react"
import { cn } from "utils/cn";


type BodyContainerStyles = {
  closedStyles: string,
  openStyles: string,
  customStyles: string,
}

type HeaderContainerStyles = {
  closedStyles: string,
  openStyles: string,
  customStyles: string,
};

interface ChevronCollapsibleProps {
  HeaderContent: JSX.Element | ReactNode;
  headerContainerStyles?: HeaderContainerStyles;
  BodyContent: JSX.Element | ReactNode;
  bodyContainerStyles?: BodyContainerStyles;
  onToggleClick?: (isOpen: boolean) => void;
  className?: string;
  closedClassName?: string;
  openClassName?: string;
}

const ChevronCollapsible = ({
  className, HeaderContent, BodyContent, onToggleClick = () => {},
  openClassName, closedClassName, headerContainerStyles, bodyContainerStyles,
}: ChevronCollapsibleProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const id = useId();

  return (
    <div 
      className={cn(
        "FN-chevron-collapsible",
        className
      )}
      id={`${id}-collapsible`}
    >
      <div
        className={cn(
          "FN-chevron-collapsible-header w-full px-6 h-[50px] flex justify-between items-center",
          headerContainerStyles?.closedStyles,
          headerContainerStyles?.openStyles,
          headerContainerStyles?.customStyles,
        )}
        id={`${id}-collapsible-header`}
      >
        {HeaderContent}

        <button
          className="flex justify-center items-center"
          onClick={() => {
            setIsOpen(!isOpen);
            onToggleClick(!isOpen);
          }}
          id={`${id}-collapsible-toggler`}
          aria-expanded={isOpen}
          aria-controls={`${id}-collapsible`}
        >
          <i
            className={cn(
              "fa-solid w-[16px] h-[22px]",
              isOpen ? "fa-chevron-up" : "fa-chevron-down"
            )}
          />
        </button>
      </div>
      <div
        className={cn(
          "FN-chevron-collapsible-body px-6",
          isOpen ? `FN-chevron-collapsible-open ${openClassName}` : `FN-chevron-collapsible-closed ${closedClassName}`,
          bodyContainerStyles?.closedStyles,
          bodyContainerStyles?.openStyles,
          bodyContainerStyles?.customStyles,
        )}
        id={`${id}-collapsible-body`}
      >
        {BodyContent}
      </div>
    </div>
  )
};

export default ChevronCollapsible;